import { css } from '@emotion/react';
import Page from 'components/Page/Page';
import { Alert, Grid, Paper, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';

export default function UnavailableProjectPage() {
  const { projectId } = useParams() as { projectId: string };

  return (
    <Page>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        css={css`
          flex-grow: 1;
        `}
      >
        <Paper
          elevation={2}
          css={css`
            text-align: center;
            padding: 2rem;
          `}
        >
          <Typography component="h1" variant="h3">
            Not available
          </Typography>
          <Alert
            severity="warning"
            css={css`
              margin-top: 32px;
            `}
          >
            You don&apos;t have access to project <em>{projectId}</em>.
          </Alert>
        </Paper>
      </Grid>
    </Page>
  );
}
